import axios from '@/assets/js/axios'
import Urls from '@/assets/js/Urls'

/**
 * 获取锦囊列表
 * @param data
 */
export function getJinNangList(data, viewState) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/JinNang/Data/GoodsProductPage`,
    method: 'post',
    data,
    headers: {
      'Ykt-ViewState': viewState
    }
  })
    .then(result => {
      return result
    })
    .catch(() => null)
}
